import { useContext, useEffect, useState } from "react";
import { Woo } from "../../Helpers/Woo";
import { Context } from "../Context/GlobalContext";
import { useLocalStorage } from "./useLocalStorage";

export function useProductCategoriesData() {
  const ls = useLocalStorage();
  const {
    categoriesLoading,
    setCategoriesLoading,
    setSelectedCategory,
    categories,
    setCategories,
    langRefreshKey,
  } = useContext(Context);
  const [error, setError] = useState(false);

  useEffect(() => {
    const cached = ls.getJSON("categories");

    if (cached && cached.length) {
      setCategories(cached);
      setCategoriesLoading(false);
      setSelectedCategory(
        cached.sort((a, b) => (a.menu_order < b.menu_order ? -1 : 1))[0]
      );
    } else {
      setCategoriesLoading(true);
    }

    Woo.categories
      .all()
      .then((data) => {
        setCategoriesLoading(false);

        setCategories(data);
        ls.setJSON("categories", data);
        setSelectedCategory(
          data.sort((a, b) => (a.menu_order < b.menu_order ? -1 : 1))[0]
        );
      })
      .catch((e) => {
        setError(e);
        setCategoriesLoading(false);
      });
  }, [langRefreshKey]);

  return { categories, categoriesLoading, error };
}
